/**
 * Chart Export Menu Component
 * Dropdown menu for exporting chart data in various formats
 */

import { MoreVertical, FileSpreadsheet, FileText, ImageIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

interface ChartExportMenuProps {
  onExportCSV: () => void
  onExportExcel: () => void
  onExportPNG?: () => void
  showImageExport?: boolean
}

export function ChartExportMenu({
  onExportCSV,
  onExportExcel,
  onExportPNG,
  showImageExport = true,
}: ChartExportMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="icon" 
          className="h-8 w-8 text-muted-foreground hover:text-foreground"
        >
          <MoreVertical className="h-4 w-4" />
          <span className="sr-only">Export options</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onSelect={onExportCSV} className="cursor-pointer">
          <FileText className="mr-2 h-4 w-4" />
          Export CSV
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={onExportExcel} className="cursor-pointer">
          <FileSpreadsheet className="mr-2 h-4 w-4" />
          Export Excel (.xlsx)
        </DropdownMenuItem>
        {showImageExport && onExportPNG && (
          <DropdownMenuItem onSelect={onExportPNG} className="cursor-pointer">
            <ImageIcon className="mr-2 h-4 w-4" />
            Export Image (PNG)
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

